import React, { PureComponent } from 'react';
import PropTypes from "prop-types";

import { MessageCard, InvoiceTile } from "@simplybenefits/sb-ui-library";


class AsoHistory extends PureComponent {
    render() {
        const { history } = this.props;
        const styles = {
            historyContainer: {
                display: 'flex',
                flexWrap: 'wrap',
                flexDirection: 'row'
            }
        };

        return (
            <div style={ styles.historyContainer }>
                {
                    !history || history.length === 0 ?
                        <MessageCard
                            title="No ASO History"
                            subtitle="Your account has no ASO History."
                        />
                        :
                        this.props.history.map((report, i) => (
                            <InvoiceTile
                                testid={ i === 0 ? 'aso-report-tile' : undefined }
                                key={ report.dateAdded }
                                date={ report.dateAdded }
                                total={ report.closingBalance }
                                status="Balance"
                                onClick={ () => this.props.selectReport(report) }
                            />
                        ))
                }
            </div>
        );
    }
}

AsoHistory.propTypes = {
    history: PropTypes.array
};

export default (AsoHistory);